module.exports = __webpack_public_path__ + "img/08.3273921a.gif";